<!-- 教练小红花排行 -->
<template>
  <div class="coach-store">
    <div class="city-container">
      <div class="city-list">
        <div
          class="city-item"
          :class="{ 'city-item-active': active == index }"
          v-for="(item, index) in cityList"
          :key="index"
          @click="bindClick(index)"
          >{{ item.name }}</div
        >
      </div>
    </div>
    <div class="store-flex">
      <div
        class="store-scroll"
        :class="{ 'store-scorll-disabled': !scroll }"
        v-for="(tabitem, tabindex) in computeStoreData"
        :key="tabindex"
        v-show="tabindex == active"
      >
        <div class="store-list">
          <div
            class="store-item"
            @click="bindToStoreDetail(item)"
            v-for="(item, index) in tabitem.list"
            :key="index"
          >
            <div class="store-item-top">
              <img class="store-image" :src="item.store_images" alt="" />
              <div class="store-mask"></div>
              <div class="my-store" v-if="item.is_my_store">我的门店</div>
              <div class="store-rank" v-if="index < 3">
                <img class="rank-icon" :src="rankIconList[index]" alt="" />
              </div>
              <div class="rank-index" v-else>{{ index + 1 }}</div>
              <div class="store-info">
                <div class="store-flower">
                  <img
                    class="flower-image"
                    src="https://btw-common-data.betterwestar.com/btw-admin/resource/71ba3142596f4cf6b18e50e08fa3ca17_wh=66_66.png"
                    alt=""
                  />
                  <div class="flower-num">{{ item.vote_num }}</div>
                </div>
                <div class="store-name">{{ item.store_name }}</div>
              </div>
              <div class="look-more"
                >查看热门教练<span class="iconfont icon-you"></span
              ></div>
            </div>
            <div
              class="store-item-bottom"
              v-if="item.recommend_coach_id"
              @click.stop="bindToCoachHome(item)"
            >
              <img class="avatar" :src="item.recommend_coach_image" alt="" />
              <div class="store-item-flex">
                <div class="item-coach-info">
                  <div class="coach-name">{{ item.recommend_coach_name }}</div>
                  <div class="recommend">推荐</div>
                </div>
              </div>
              <div class="coach-home">查看Ta的主页</div>
            </div>
          </div>
          <img
            v-if="tabitem.list.length"
            class="gray-logo"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/105e8b8098652ec924de3cec5ec06d35_wh=390_33.png"
            alt=""
          />
          <div class="empty" v-if="tabitem.loaded && !tabitem.list.length">
            <img
              class="empty-image"
              src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
              alt=""
            />
            <div class="empty-text">暂无门店</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rankIconList: [
        'https://btw-common-data.betterwestar.com/btw-admin/resource/3f9daa01d500d3bd5866c7c78fd04010_wh=111_147.png',
        'https://btw-common-data.betterwestar.com/btw-admin/resource/f9d30a3457226f39369d76b09889af18_wh=111_147.png',
        'https://btw-common-data.betterwestar.com/btw-admin/resource/6e750784ed319b5fc6ece79c984f1fb8_wh=111_147.png'
      ],
      active: 0,
      cityList: [
        {
          name: '长沙',
          code: '4301'
        },
        {
          name: '南京',
          code: '3201'
        },
        {
          name: '苏州',
          code: '3205'
        }
      ],
      storeData: [
        {
          list: [],
          loaded: false
        },
        {
          list: [],
          loaded: false
        },
        {
          list: [],
          loaded: false
        }
      ]
    }
  },
  created() {
    this.init()
    this.getStoreRank()
  },
  computed: {
    activityData() {
      return this.$store.state.coachActivity2024.activityData
    },
    computeStoreData() {
      return this.$store.state.coachActivity2024.storeRankData.storeData
    }
  },
  methods: {
    bindToCoachHome(item) {
      let id = item.recommend_coach_id
      if (id) {
        this.$betterwe.jumpRoute('/userDetailsPage?id=' + id)
      }
    },
    init() {
      let code = this.activityData?.city_code
      if (code) {
        this.cityList.map((item, index) => {
          if (item.code == code) {
            this.active = index
          }
        })
      }
    },
    bindClick(index) {
      this.active = index
      if (!this.storeData[this.active].loaded) {
        this.getStoreRank()
      }
    },
    bindToStoreDetail(item) {
      if (item.store_id) {
        let url = `${location.origin}/activity/2024/store-detail?store_id=${
          item.store_id
        }&store_name=${encodeURIComponent(
          item.store_name
        )}&store_images=${encodeURIComponent(item.store_images)}&vote_num=${
          item.vote_num
        }&store_address=${encodeURIComponent(item.store_address)}`
        // url = ConcatUrl(url,item);
        url = `/web?url=${encodeURIComponent(url)}`
        this.$betterwe.jumpRoute(url)
      }
    },
    async getStoreRank() {
      let active = this.active
      let code = this.cityList[active].code
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/storeRank', { city_code: code })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res && res.code == 200) {
          this.storeData[active].loaded = true
          this.$store.commit('coachActivity2024/setStoreRankData', {
            cityCode: code,
            data: res.data
          })
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coach-store {
  box-sizing: border-box;
  background-color: #f9f9f9;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .city-container {
    margin-top: 16px;
    margin-bottom: 10px;
    overflow-x: scroll;
    .city-list {
      padding: 0px 20px;
      display: inline-flex;
      align-items: center;
      .city-item {
        padding: 0px 20px;
        white-space: nowrap;
        height: 28px;
        font-weight: bold;
        font-size: 14px;
        color: rgba(48, 48, 56, 0.5);
        line-height: 28px;
        border-radius: 14px;
        border: 1px solid rgba(5, 11, 39, 0.2);
        margin-right: 10px;
      }
      .city-item-active {
        border: 1px solid #050b27;
        color: #050b27;
      }
      .city-item:last-child {
        margin-right: 0;
      }
    }
  }
  .store-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .store-content {
      height: 100%;
    }
    .store-scroll {
      height: 100%;
      overflow-y: scroll;
      .store-list {
        box-sizing: border-box;
        padding: 10px 20px;
        .store-item {
          border-radius: 4px;
          overflow: hidden;
          background-color: #fff;
          margin-bottom: 8px;
          .store-item-top {
            position: relative;
            height: 172px;
            .store-image {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            .store-mask {
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.2) 49%,
                rgba(0, 0, 0, 0.6) 100%
              );
              opacity: 0.6;
            }
            .my-store {
              position: absolute;
              top: 0;
              right: 0;
              font-weight: bold;
              padding: 0px 6px;
              line-height: 23px;
              font-size: 12px;
              color: #ffffff;
              height: 23px;
              background: #ff2270;
              border-radius: 0px 4px 0px 4px;
            }
            .rank-icon {
              position: absolute;
              left: 12px;
              top: 0;
              width: 37px;
              height: 49px;
              object-fit: contain;
            }
            .rank-index {
              position: absolute;
              left: 0;
              top: 0;
              width: 36px;
              height: 30px;
              background: rgba(0, 0, 0, 0.6);
              border-radius: 4px 0px 4px 0px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              line-height: 20px;
            }
            .store-info {
              padding: 12px;
              box-sizing: border-box;
              position: absolute;
              width: 230px;
              left: 0;
              bottom: 0;
              .store-flower {
                display: inline-flex;
                align-items: center;
                height: 26px;
                background: rgba(255, 255, 255, 0.7);
                border-radius: 13px;
                padding: 0px 12px;
                font-family: DIN;
                font-weight: bold;
                font-size: 20px;
                color: #ff2270;
                line-height: 26px;
                margin-bottom: 5px;
                .flower-image {
                  width: 16px;
                  height: 16px;
                  object-fit: contain;
                  margin-right: 5px;
                }
                .flower-num {
                  white-space: nowrap;
                }
              }
              .store-name {
                white-space: normal;
                text-overflow: ellipsis;
                overflow: hidden;
                font-weight: bold;
                font-size: 16px;
                color: #ffffff;
                line-height: 22px;
              }
            }
            .look-more {
              position: absolute;
              bottom: 15px;
              right: 12px;
              font-weight: 500;
              font-size: 12px;
              color: #ffffff;
              line-height: 17px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .store-item-bottom {
            padding: 12px;
            display: flex;
            align-items: center;
            .avatar {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              overflow: hidden;
              object-fit: cover;
              margin-right: 8px;
            }
            .store-item-flex {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              .item-coach-info {
                display: flex;
                align-items: center;
                .coach-name {
                  font-weight: bold;
                  font-size: 14px;
                  color: #303038;
                  line-height: 20px;
                  margin-right: 4px;
                }
                .recommend {
                  padding: 0px 6px;
                  height: 14px;
                  background: rgba(48, 48, 56, 0.1);
                  border-radius: 7px;
                  font-size: 9px;
                  color: #303038;
                  line-height: 14px;
                }
              }
              .item-hot {
                white-space: nowrap;
                font-size: 12px;
                color: rgba(5, 11, 39, 0.7);
                line-height: 17px;
              }
            }
            .coach-home {
              width: 99px;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 14px;
              border: 1px solid rgba(5, 11, 39, 0.2);
              font-weight: bold;
              font-size: 12px;
              color: #050b27;
            }
          }
        }
        .store-item:last-child {
          margin-bottom: 0;
        }
        .gray-logo {
          margin: 30px auto 40px;
          width: 130px;
          height: 11px;
          object-fit: contain;
        }
      }
    }
    .store-scorll-disabled {
      overflow-y: hidden;
    }
  }
  .empty {
    width: 100%;
    height: 272px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-image {
      width: 214px;
      height: 112px;
      object-fit: contain;
      margin-bottom: 25px;
    }
    .empty-text {
      font-weight: bold;
      font-size: 16px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 22px;
    }
  }
}
</style>
